
// Define the SimulationTrackerStatus enum or type if it exists
export enum SimulationTrackerStatusMessage {
    Pending = 'Pending',
    Running = 'Running',
    Completed = 'Completed',
    Failed = 'Failed',
    GeneratingResults = 'Generating Results',
    Unknown = 'Unknown',
}

/**
 * Enum representing the various statuses of a simulation tracker.
 *
 * @enum {number}
 * @property {number} Pending - The simulation is pending and has not started yet.
 * @property {number} Running - The simulation is currently in progress.
 * @property {number} Completed - The simulation is complete and has results.
 * @property {number} Failed - The simulation has failed.
 * @property {number} GeneratingResults - The simulation has completed and is in the process of generating results.
 */
export enum SimulationTrackerStatus {
  Pending = 0,
  Running = 1,
  Completed = 2,
  Failed = 3,
  GeneratingResults = 4
}

